
import service from "../services/user.service"; // Asegúrate de que el servicio esté configurado correctamente

export const users = {
    namespaced: true,
    state: {
        users: [],
        currentPage: 1,
        lastPage: 1,
        links:[],
        searchQuery: '',
        globalTotals: { laborado: 0, pagado: 0, pendiente: 0 },
        allUsersCache: null,
        allUsersCacheTime: null,
        oficiosCache: null,
        oficiosCacheTime: null,
    },
    getters: {
        allUsers: (state) => state.users,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        searchQuery: (state) => state.searchQuery,
        globalTotals: (state) => state.globalTotals,
    },
    actions: {
        async fetchUsers({ commit },pageUrl = null) {
            try {
                const response = await service.getUsers(pageUrl);
                const payload = response.data;
                // Soporte para respuestas paginadas Laravel (data.data) o arrays planos
                const rows = payload && payload.data ? (Array.isArray(payload.data) ? payload.data : (payload.data.data || [])) : [];
                commit('SET_USERS', rows);
                commit('SET_PAGINATION', {
                    currentPage: payload.current_page ?? (payload.data?.current_page ?? 1),
                    lastPage: payload.last_page ?? (payload.data?.last_page ?? 1),
                    links: payload.links ?? (payload.data?.links ?? []),
                });
                const gt = payload.global_totals ?? payload.data?.global_totals;
                if (gt) {
                    commit('SET_GLOBAL_TOTALS', gt);
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        },
        async save(context,data) {
            try {
                let response;
                if(data.id==0){
                    response = await service.createUser(data);
                }else{
                    response = await service.updateUser(data.id,data);
                }
               
                return response; 
            } catch (error) {
                console.error("Error save users:", error);
                return error.response; 
            }
        },
        async delete(context, userId) {
            try {
                const response = await service.deleteUser(userId);
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
        async getOficios({ commit, state }) {
            const now = Date.now();
            if (state.oficiosCache && state.oficiosCacheTime && (now - state.oficiosCacheTime < 300000)) {
                return state.oficiosCache;
            }
            try {
                const response = await service.getOficios();
                commit('SET_OFICIOS_CACHE', response.data);
                commit('SET_OFICIOS_CACHE_TIME', now);
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getAll({ commit, state }) {
            const now = Date.now();
            if (state.allUsersCache && state.allUsersCacheTime && (now - state.allUsersCacheTime < 300000)) {
                return state.allUsersCache;
            }
            try {
                const response = await service.getAll('all');
                commit('SET_ALL_USERS_CACHE', response.data);
                commit('SET_ALL_USERS_CACHE_TIME', now);
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },  
    },
    mutations: {
        SET_USERS(state, users) {
            state.users = users;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        ADD_USER(state, user) {
            state.users.push(user); // Agrega el nuevo usuario al array de usuarios
        },
        SET_SEARCH_QUERY(state, query) {
            state.searchQuery = query;
        },
        SET_GLOBAL_TOTALS(state, totals) {
            state.globalTotals = {
                laborado: parseFloat(totals.laborado || 0),
                pagado: parseFloat(totals.pagado || 0),
                pendiente: parseFloat(totals.pendiente || 0),
            };
        },
        SET_ALL_USERS_CACHE(state, data) {
            state.allUsersCache = data;
        },
        SET_ALL_USERS_CACHE_TIME(state, time) {
            state.allUsersCacheTime = time;
        },
        SET_OFICIOS_CACHE(state, data) {
            state.oficiosCache = data;
        },
        SET_OFICIOS_CACHE_TIME(state, time) {
            state.oficiosCacheTime = time;
        }
    },
};